import { useCallback } from 'react'

import { useWatch } from 'react-hook-form'

import { fetch as fetchOperators } from '@/services/operators/fetch'
import { buildDatesParams } from '@/utils/build-dates-params'
import { formatBrDateToIso } from '@/utils/format-br-date-to-iso'
import { getLast31DaysPeriod } from '@/utils/get-last-31-days-period'

const PAGE_SIZE = 10

export const useOperatorsOptions = ({ control }: { control: any }) => {
  const watchedPeriod = useWatch({ name: 'dataDoItem', control })

  const dates = getLast31DaysPeriod().split(' - ')
  const defaultStartDate = formatBrDateToIso(dates[0])
  const defaultEndDate = formatBrDateToIso(dates[1])

  const loadOptions = useCallback(
    async (
      inputValue: string,
      _loadedOptions: unknown,
      additional?: { page: number }
    ) => {
      const page = additional?.page ?? 1
      const period = watchedPeriod || `${defaultStartDate} - ${defaultEndDate}`
      const periodParams = buildDatesParams(period)
      const startDate = periodParams?.StartDate
      const endDate = periodParams?.EndDate

      if (!startDate || !endDate || (inputValue && inputValue.length < 2)) {
        return { options: [], hasMore: false, additional: { page: 1 } }
      }

      try {
        const data = await fetchOperators(
          inputValue,
          page,
          PAGE_SIZE,
          startDate,
          endDate
        )

        const hasMore =
          data.items.length === PAGE_SIZE && data.total > page * PAGE_SIZE
        return { options: data.items, hasMore, additional: { page: page + 1 } }
      } catch (error) {
        console.error('Error loading operators:', error)
        return { options: [], hasMore: false, additional: { page: 1 } }
      }
    },
    [watchedPeriod]
  )

  return { loadOptions }
}
